import { ReportingSectorsService } from '@/modules/global-settings/loan-origination/services/other-settings/reporting-sectors.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Create a new instance of the ReportingSectorsService class
const reportSectorsService = new ReportingSectorsService();
// Define the state of the module
export const state = {
  reportingSectors: [],
  selectedPrimarySector: {}
};
// Define the mutations of the module
export const mutations = {
  ...make.mutations(state)
};
// Define the actions of the module
export const actions = {
  async getSectors({ commit, state }) {
    try {
      const { data } = await reportSectorsService.fetchSectors();
      commit('SET_REPORTING_SECTORS', data);
      if (
        state.selectedPrimarySector &&
        Object.prototype.hasOwnProperty.call(state.selectedPrimarySector, 'id')
      ) {
        commit(
          'SET_SELECTED_PRIMARY_SECTOR',
          state.reportingSectors.find(
            (report) => (report.id === state.selectedPrimarySector.id)
          ) || {}
        );
      }
      return data;
    } catch (error) {
      Logger.error('getting reporting sectors');
      throw error;
    }
  },

  async createPrimarySector({ dispatch }, payload) {
    try {
      const { data } = await reportSectorsService.createPrimarySector(payload);
      dispatch('getSectors');
      return data;
    } catch (error) {
      Logger.error('creating reporting sector');
      throw error;
    }
  },

  async createSecondarySector(
    { dispatch },
    { primarySector, secondarySector }
  ) {
    try {
      const { data } = await reportSectorsService.createSecondarySector(
        primarySector,
        secondarySector
      );
      dispatch('getSectors');
      return data;
    } catch (error) {
      Logger.error('creating reporting sector');
      throw error;
    }
  },

  async createSubSecondarySector(
    { dispatch },
    { primarySector, secondarySector, subSecondarySector }
  ) {
    try {
      const { data } = await reportSectorsService.createSubSecondarySector(
        primarySector,
        secondarySector,
        subSecondarySector
      );
      dispatch('getSectors');
      return data;
    } catch (error) {
      Logger.error('creating reporting sector');
      throw error;
    }
  },

  async updateSectors({ dispatch }, { id, payload }) {
    try {
      const result = await reportSectorsService.updateSector(id, payload);
      dispatch('getSectors');
      return result;
    } catch (error) {
      Logger.error('updating reporting sector');
      throw error;
    }
  },

  async deletePrimarySector({ dispatch }, primaryId) {
    const { status } = await reportSectorsService.deletePrimarySector(
      primaryId
    );
    if (status == 200) {
      dispatch('getSectors');
    }
    return status;
  },

  async deleteSecondarySector(
    { dispatch },
    { primarySectorId, secondarySectorId }
  ) {
    const { status } = await reportSectorsService.deleteSecondarySector(
      primarySectorId,
      secondarySectorId
    );
    if (status == 200) {
      dispatch('getSectors');
    }
    return status;
  },

  async deleteSubSecondarySector(
    { dispatch },
    { primarySectorId, secondarySectorId, subSecondarySectorId }
  ) {
    const { status } = await reportSectorsService.deleteSubSecondarySector(
      primarySectorId,
      secondarySectorId,
      subSecondarySectorId
    );
    if (status == 200) {
      dispatch('getSectors');
    }
    return status;
  },

  setSelectedPrimarySector({ commit }, payload) {
    commit('SET_SELECTED_PRIMARY_SECTOR', payload);
  }
};
